var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "history_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-3-3h22v22H-3z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#history_svg__a)",
    "data-name": "Scroll Group 37",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(3 3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414e5f",
    stroke: "#414e5f",
    strokeWidth: 0.3,
    d: "M8.469 3.781v3.412a.935.935 0 0 1 .339.339h2.474a.469.469 0 0 1 0 .938H8.807a.935.935 0 1 1-1.276-1.277V3.781a.469.469 0 0 1 .938 0ZM8 .5a7.488 7.488 0 0 0-6.094 3.127V1.906a.469.469 0 0 0-.937 0v2.813a.469.469 0 0 0 .469.469H4.25a.469.469 0 0 0 0-.937H2.617A6.56 6.56 0 1 1 1.438 8 .469.469 0 0 0 .5 8 7.5 7.5 0 1 0 8 .5Z"
  }))));
};
export default SvgHistory;